<div class="d-flex flex-column align-items-center font-size-12 mb-2 footer-margin">
  <p class="copyright-text mb-1">
    Copyright © {{ currentYear }}. All rights reserved.
  </p>
  <a (click)="openLink()" aria-disabled="false" ddsFocus class="dds-link">
    Deloitte Web Privacy Notice
  </a>
</div>
